import api from '../../../App/socket';

export const setLeadApproveReport = params => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'LeadApprove',
    options:
                      {
                          where: {
                              lead_id: params.lead_id,
                          },
                          approval: {
                              [params.approve_kind]: {
                                  value: params.approve_value,
                              },
                          },

                      },
})
    .then(response => response)
    .catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_approval/requests/set_lead_approve_request.js